import arrowRightUrl from "@/assets/brand-arrow-right.svg";
import arrowUpRightUrl from "@/assets/brand-arrow-up-right.svg";

type BrandArrowProps = {
  direction?: "right" | "up-right";
  className?: string;
};

/** Точные векторы стрелок из брендбука WMT AI (Figma 58:1841). */
const BrandArrow = ({
  direction = "right",
  className = "h-5 w-5",
}: BrandArrowProps) => {
  const assetUrl = direction === "up-right" ? arrowUpRightUrl : arrowRightUrl;

  return (
    <span
      className={`inline-block shrink-0 bg-current ${className}`}
      style={{
        WebkitMaskImage: `url("${assetUrl}")`,
        maskImage: `url("${assetUrl}")`,
        WebkitMaskPosition: "center",
        maskPosition: "center",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskSize: "contain",
        maskSize: "contain",
      }}
      aria-hidden="true"
    />
  );
};

export default BrandArrow;
